<template>
  <div class="download_div">
    <div class="module">
      <Header :navIndex="2"/>
      <div class="download_scroll">
        <a-row style="margin-top: 30px">
          <a-col class="txt_download_title">下载喵呜AI</a-col>
        </a-row>
        <a-row style="margin-top: 30px;padding: 0 10px">
          <a-col class="txt_download_desc">下载喵呜AI软件，领取你的专属AI智能体，支持IOS和Android两个平台</a-col>
        </a-row>
        <a-row type="flex" justify="center" style="margin-top: 50px">
          <a-col :span="24" style="text-align: center;display: flex; justify-content: center;">
            <div class="download_div_item download_div_left">
              <div class="div_left download_div_left_item">
                客户端下载
              </div>
              <div class="div_left download_div_left_item">
                微信扫码立即下载手机app
              </div>
              <div class="div_left download_div_left_item">
                <img :src="qrCode" width="218px"/>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <!--底部版权声明-->
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from './HeaderMobile.vue'
import Footer from './../Footer.vue'

export default {
  name: 'MyComponent',
  components: { Header, Footer },
  props: [],
  data () {
    return {
      sum: '0',
      qrCode: require('@/assets/qrcode.png')
    }
  },
  computed: {
  },
  created () {
    if (!this.$store.state.isMobile) {
      this.$router.push('/download')
    }
  },
  methods: {
    downPc () {
      console.log('downPc')
      window.location.href = 'https://awu-file.oss-cn-guangzhou.aliyuncs.com/mnt/data/resource/mainview.zip'
    }
  }
}
</script>

<style scoped lang="less">
  .download_div{
    height: 100vh;
    overflow: auto; /* 使用 auto 属性显示滚动条 */
  }
  .txt_download_title{
    height: 67px;
    font-size: 48px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 56px;
  }
  .txt_download_desc{
    height: 31px;
    font-size: 22px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
  }
  .download_div_left{
    width: 318px;
    height: 354px;
    background: rgb(49, 54, 66);
    border-radius: 0;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 23px;
    padding: 30px;
    text-align: center;
    .download_div_left_item{
      margin-bottom: 16px;
    }
  }
  .download_div_right{
    width: 318px;
    height: 354px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgba(40,224,74,0.6);
    padding: 50px 30px ;
    .download_div_right_item{
      margin-bottom: 30px;
    }
    .download_div_right_pre{
      font-size: 18px;
      font-weight: 300;
      color: rgba(255,255,255,0.8);
      line-height: 32px;
    }
    .download_div_right_content{
      font-size: 20px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 23px;
    }
    .text_download{
      position: relative;
      cursor: pointer;
    }
    .text_download::after {
      content: "";
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: white;
    }
  }
  .download_scroll{
    width: 100%;
    height: calc(100vh - 200px);
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/DownloadMobile.vue